import { API, axiosInstance } from "lib";

export const getVehicleDocTypeListData = (data = {}) => {
  return axiosInstance
    .post(API.GET_VEHICLE_DOC_TYPE_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const createVehicleDocType = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_VEHICLE_DOC_TYPE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const editVehicleDocType = (data = {}, id) => {
  return axiosInstance
    .put(API.EDIT_VEHICLE_DOC_TYPE + "/" + id, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getSingleVehicleDocData = (data = {}) => {
  return axiosInstance
    .post(API.GET_SINGLE_VEHICLE_DOC_TYPE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const deleteVehicleDocData = (data = {}) => {
  return axiosInstance
    .delete(API.DELETE_VEHICLE_DOC_TYPE + "/" + data?.id, {})
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

// In masters vehicle (truck) section vehicle documents api's

export const getVehicleDocumentsListData = (data = {}) => {
  return axiosInstance
    .post(API.GET_VEHICLE_DOCUMENTS_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const createVehicleDocuments = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_VEHICLE_DOCUMENTS, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const editVehicleDocuments = (data = {}, id) => {
  return axiosInstance
    .put(API.EDIT_VEHICLE_DOCUMENTS + "/" + id, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getSingleVehicleDocumentData = (data = {}) => {
  return axiosInstance
    .post(API.GET_SINGLE_VEHICLE_DOCUMENT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const deleteVehicleDocumentData = (data = {}) => {
  return axiosInstance
    .delete(API.DELETE_VEHICLE_DOCUMENT + "/" + data?.id, {})
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};


// vehicle details GPS Settings

export const updateGpsSettings = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_VEHICLE_GPS_SETTINGS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const deleteImageVehicleDocument = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_IMAGE_VEHICLE_DOCUMENT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const exportVehicleDocumentsummaryReport = (data = {}) => {
  return axiosInstance
    .post(API.EXPORT_VEHICLE_DOCUMENT_SUMMARY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const VehicleDocumentFetch = (data = {}) => {
  return axiosInstance
    .post(API.VEHICLE_DOCUMENT_FETCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getDocumentVehicleCounts = (data = {}) => {
  return axiosInstance
    .post(API.VEHICLE_DOCUMENT_COUNTS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};